import { parentsRoutes } from "@pages/parents/routes";

export const userLinks = [
    { label: "Обучение", to: "/program/" },
    {
        label: "Магазин",
        dropdown: [
            { label: "Товары", to: "/shop/" },
            { label: "Мои заказы", to: "/orders/" },
        ],
    },
    { label: "Челленджи", to: "/challenges/" },
    { label: "Турниры", to: "/tournaments/" },
    {
        label: "Для родителей",
        dropdown: parentsRoutes.map(({ label, path }) => ({ label, to: path })),
    },

    { label: "Техподдержка", isSentryFeedback: true },
];
